import { State } from '~/store/types';
import { SiteEntryProps, PlaneEntryProps, Site } from '@ixicare/resources';
import { action, makeAutoObservable } from 'mobx';
import { UserAction } from '~/config/notification';
import { t } from '~/i18n';

class BuildingStore {
  rootStore: State;
  id: number;
  address: string;
  lat: number;
  long: number;
  planes: PlaneEntryProps[];
  slug: string;
  uuid: string;
  name: string;
  constructor(rootStore: State, building: SiteEntryProps) {
    makeAutoObservable(this, { uploadFloorMap: action.bound });
    this.rootStore = rootStore;
    this.id = building.id;
    this.uuid = building.uuid;
    this.planes = building.planes;
    this.slug = building.slug;
    this.name = building.name;
    this.uuid = building.uuid;
  }

  uploadFloorMap(props: {
    name: string;
    floor: number;
    floorWidth?: number;
    floorHeight?: number;
    map: File;
  }): Promise<PlaneEntryProps> {
    return new Promise((resolve) => {
      Site.submitFloor(this.id, {
        mapFile: props.map,
        floorName: props.name,
        floorNumber: props.floor,
      }).then((data) => {
        this.rootStore.notifications.addUserActionNotification({
          type: UserAction.SiteFloorCreate,
          notificationType: 'success',
          message: t('alerts.buildings.floor.create.success', {
            floorName: props.name,
          }),
        });

        resolve(data);
      });
    });
  }
}

export default BuildingStore;
